'use strict';

/**
 * Collection for shops
 *
 * @category   Collection
 * @module     collection
 * @copyright  Copyright (c) 2017, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var ShopModel = require('../models/shop');

var ShopsCollection = Collection.extend({
    // api: '/catalogs', //@todo move to /shops
    api: '/shops',

    name: 'collection:shops',

    model: ShopModel,

    activeShop: null,

    initialize: function(models, options) {
        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },

    getActiveShop: function() {
        return this.activeShop || this.at(0);
    },

    setActiveShop: function(id) {
        var newActiveShop = this.get(id) || this.at(0);

        if (newActiveShop !== this.activeShop) {
            this.activeShop = newActiveShop;
            this.trigger('change');
            this.trigger('change:activeShop', newActiveShop);
        }
    },
});

module.exports = ShopsCollection;